import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionEquipment, constructionSafety } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import video from '@src/assets/images/solution/constructionEquipment/video/rtlsVideo.mp4';

export default {
  desc: 'Giải pháp định vị vị trí bằng AI Camera sử dụng công nghệ Trí tuệ nhân tạo (AI) để phân tích và xử lý dữ liệu video từ camera, từ đó theo dõi vị trí của người và phương tiện theo thời gian thực.',
  keywords: 'AICamera,Theo dõi vị trí,Theo doi vi tri,Định vị vị trí,Dinh vi vi tri,Theo dõi phương tiện,Theo doi phuong tien,DigitalTwin',
  ogSite: 'Giải pháp định vị vị trí bằng AI Camera',
  title: 'Giải pháp định vị vị trí bằng AI Camera',
  ogUrl: 'https://orbro.io/vi/blog/ai-camera',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDkc4tGW9Sjxkfqer33MMng2ket3NNLJzV7Iz2LLirs_1Vbk4Lhm63aO_z8WWd2dIov4g4YuW4_LF8fiQn1v8CAQMxvfMbY58snCZaz5-tmYX7MljahebCQULlqUN3wwe4XqTP-9XdR2jE5QpHWOWD2ddnpV3jfnK3qIltSnKR3JEpPdmrECN49rXQbSa7jNtNAFPC71gTTRBtV-koIsqQYpX0un1kLVJJZxwlqQNH5_tGeA9HHAmQRhtGxmF0IkPCicaA2wexfmrwboGdPR9_tkKklNF54F6EulnMKypq_qaskVAEZvDlYArvBFhnatgUVy0Uh4yo-mw9wek4fNrsUOfIb2QjUoGzYVul27F9GFN5eXULvD3zPSTOeZHF_Fy7_VBfp_A0ugMGL_EuF2olRd-eBnVJt3xGOvMOIfgcA6AfXHOmhu7sbHo1yBoJ6cyTvJQzLMafMxmStxH5CKMzD_3FKEw0pJ25EuuAy7I5e8Pp_LxdZg_GjN8cj5qXbhIpnxCfSmd5KOol3tgfS1jCnXsAbDJ_XSVp4EBn_zgXhTswmP02m9R2XxafKdWMa-ZhZE5l4o_T_ZBOoWKwRfJXJtMcTJspT2tOfode7mVpQFhU5pa6KtAqcJtVuS1i2r4rjQDEI92DQCh0CDmnkM041jtKKL9oFXlO0GQLOX0j_Z7O1R3qZ0awsO_O7gBkBGK0CJ0PlT2_JW3eGFtPu5zROSwOKF-7rcJMH1f6R29Nf1bhejjB2zRRyISB5J6Psjf7wk3LffQaSUsmJy1Wl_J11fQUBTzMAl-mUnwqquWh2eEijlvT-y4Ixu8zeRJSM7Fk61_nWCu6F48eu4Ge_4geMR2DOjfQOnLqKKfSWY_XdzxDDeACmf6PTAgeWFDzx7MZJ6vN7yp75G8Ez9xTKMQGpcfn4qwI8oA2W3qx_NtVJ6AFT0dD7vLS87ML4D7eHI8uB2pjBlqb6v4rbxp41pQGAQ_VuldNTZNUZH8q2ddGnDJ1PVh_eKBB7uoGEPUO2Lbvws6VRw93FJDgIzqXUkPwDHMVOhhjsFBWBcBQtOh2fbVWyT1k9_jRFfeo2zJ3hPWat4kTns5Ew671LTXXGJwXGHGQB0bqGCqwhwBJGjwlPS7NFxhhDYocq8P-a1r6dyKzlEmh18hbWIc-Rz7z8h0_Fv-a4EeOmoNwTQMQl1QaWugyzqkqs1wUDKtJb7dHQBcMSkzJe-fylN3_peFQAyizDmhXmlZmjYqOOCHEXHuEyxbL8ILOK_8KxHyahhYwMSk13KrKVMR0ThHJkCcsfyA-hS9jzo4Ww8q3ARcr0R7Yb-361rI8aluKtbzPbGZHWwOQCMnDv8itfAOTiVU8l3vEfE6TPQUytUs03-_CGTmMrgpoxFxRDPkJFNwEa0671QbXV5AwJNTviSSe9q27H-I59Id0McwUZGQBn0z8XOjoJyCBZ27zRD9tSbBg-B1s1crfHk5RU8bIvgfwCsov_1oVufbxVy223DtdDzlernhw9DYzq5IUYKPoL-lZXZiS4er28lhBzPfXz4feDNHNSzB0cP_-4p-UlNtXaQtKzLGIu3WX-VqHW-=w2059-h1270',
  ogType: 'website',
  date: '2024-02-07',
  tag1: 'AICamera',
  tag2: 'Theodoivitri',
  tag3: 'Dinhvivitri',
  tag4: 'Theodoiphuongtien',
  text: [
    {
      head: 'AI Camera là gì?',
      subHead: '',
      desc: 'Giải pháp định vị vị trí bằng AI Camera sử dụng công nghệ Trí tuệ nhân tạo (AI) để phân tích và xử lý dữ liệu video từ camera, từ đó theo dõi vị trí của người và phương tiện theo thời gian thực. Thông qua đó, nó có thể được ứng dụng trong nhiều lĩnh vực khác nhau như an ninh, quản lý giao thông và giám sát video. Nói cách khác, khác với camera thông thường, AI camera có thể hoạt động một cách thông minh hơn bằng cách phân tích và xử lý dữ liệu video.',
      dot: '',
    },
    {
      head: 'Các tính năng chính của AI Camera',
      subHead: 'Theo dõi vị trí theo thời gian thực',
      desc: 'AI Camera nhanh chóng và chính xác theo dõi chuyển động của người và phương tiện theo thời gian thực, xác định và ghi lại vị trí hiện tại của họ. Thông qua đó, trong hệ thống an ninh, nó có thể nhanh chóng xác định các mối đe dọa tiềm ẩn, và trong hệ thống quản lý giao thông, nó có thể giám sát luồng giao thông theo thời gian thực và thực hiện các biện pháp phù hợp với tình hình.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phân tích và nhận diện hình ảnh',
      desc: 'AI Camera có thể tự động nhận diện và phân loại các đối tượng khác nhau trong video thông qua phân tích video và nhận diện đối tượng. Thông qua đó, trong hệ thống an ninh, nó có thể nhanh chóng phát hiện kẻ xâm nhập hoặc hành vi bất thường, và trong hệ thống quản lý giao thông, nó có thể phân tích chính xác tình hình giao thông để ngăn ngừa vấn đề và quản lý hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hỗ trợ đa camera',
      desc: 'AI Camera có thể tích hợp nhiều camera để giám sát đồng thời một khu vực rộng lớn. Thông qua đó, nó có thể bao phủ một khu vực rộng hơn và thu thập thông tin hiệu quả từ nhiều góc độ khác nhau. Ngoài ra, bằng cách sử dụng tính năng hỗ trợ đa camera, nó có thể cung cấp giải pháp mạnh mẽ hơn trong quản lý an ninh và an toàn trong nhiều môi trường khác nhau như ngã tư hoặc các tòa nhà quy mô lớn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tính năng tùy chỉnh',
      desc: 'AI Camera cho phép người dùng thêm và cài đặt các chức năng mong muốn tùy theo nhu cầu. Tính năng tùy chỉnh có thể được điều chỉnh linh hoạt để phù hợp với nhiều môi trường khác nhau, và cung cấp khả năng giám sát chính xác và hiệu quả theo yêu cầu cụ thể. Ngoài ra, thông qua tính năng tùy chỉnh, có thể tối ưu hóa và nâng cấp hiệu suất của AI Camera.',
      dot: '',
    },
    {
      head: 'Công nghệ AI Camera',
      subHead: 'Xử lý và phân tích hình ảnh',
      desc: 'AI Camera phân tích dữ liệu video mà camera quay được một cách nhanh chóng và chính xác theo thời gian thực. Để làm điều này, các thuật toán Trí tuệ nhân tạo tiên tiến nhất được sử dụng, bao gồm các yếu tố chính như phát hiện đối tượng, theo dõi, phân loại. Thông qua các công nghệ này, AI Camera có thể nhanh chóng xử lý dữ liệu video, đồng thời nhận diện và trích xuất chính xác các đối tượng như con người và phương tiện.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phát hiện đối tượng',
      desc: 'AI Camera nhanh chóng phát hiện các đối tượng như con người và phương tiện trong video. Bằng cách sử dụng công nghệ Deep Learning tiên tiến nhất, nó có thể nhận diện và trích xuất các đối tượng một cách chính xác. Thông qua đó, AI Camera có thể nhanh chóng phát hiện các đối tượng trong nhiều môi trường khác nhau và dựa trên đó thực hiện phân tích bổ sung hoặc các biện pháp cần thiết.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Theo dõi và xác định vị trí',
      desc: 'AI Camera theo dõi chuyển động của các đối tượng đã phát hiện theo thời gian thực để xác định vị trí của chúng. Thông qua đó, AI Camera có thể liên tục giám sát chuyển động của con người và phương tiện, và phản ứng nhanh chóng khi cần thiết. Ngoài ra, bằng cách phân tích lộ trình di chuyển của các đối tượng đã theo dõi, nó có thể cung cấp thêm thông tin chi tiết.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phân tích và lưu trữ dữ liệu',
      desc: 'Dữ liệu theo dõi được phân tích và lưu trữ. Thông qua đó, AI Camera có thể phân tích mô hình di chuyển hoặc hành vi của các đối tượng đã theo dõi, và nếu cần, dữ liệu có thể được lưu trữ trong cơ sở dữ liệu để xem xét sau này hoặc sử dụng để lập báo cáo. Thông qua đó, hệ thống an ninh có thể phân tích nguyên nhân và diễn biến của sự việc để ứng phó hiệu quả hơn.',
      dot: '',
    },
    {
      head: 'Các lĩnh vực ứng dụng',
      subHead: 'Hệ thống an ninh',
      desc: 'AI Camera có thể tăng cường bảo mật bằng cách theo dõi vị trí của người và phương tiện theo thời gian thực tại những nơi cần bảo mật như bên trong tòa nhà hoặc bãi đỗ xe. Ngoài ra, bằng cách phân tích dữ liệu này, nó có thể cung cấp khả năng dự đoán và ứng phó rủi ro chính xác hơn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý giao thông',
      desc: 'Tại các cơ sở vật chất liên quan đến giao thông như đường bộ hoặc ngã tư, AI Camera có thể được sử dụng để giám sát và quản lý tình hình giao thông theo thời gian thực. Thông qua đó, có thể ngăn ngừa tắc nghẽn giao thông hoặc tai nạn giao thông từ sớm và tối ưu hóa luồng giao thông.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Mục đích thương mại',
      desc: 'Tại các cơ sở thương mại như cửa hàng hoặc trung tâm thương mại, AI Camera có thể được sử dụng để theo dõi lộ trình di chuyển và hành vi của khách hàng, từ đó tối ưu hóa bố cục cửa hàng hoặc xây dựng chiến lược tiếp thị. Ngoài ra, thông qua đó, có thể phân tích và cải thiện sở thích của khách hàng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Smart City',
      desc: 'Thông qua AI Camera được lắp đặt tại nhiều vị trí khác nhau trong thành phố, có thể nắm bắt mô hình di chuyển của công dân và quản lý hạ tầng đô thị hiệu quả. Thông qua đó, có thể nâng cao an toàn và tiện ích của thành phố, góp phần xây dựng Smart City (thành phố thông minh).',
      dot: '',
    },
    {
      head: 'Kết luận',
      subHead: '',
      desc: 'Giải pháp theo dõi vị trí bằng camera sử dụng AI là một công nghệ hiệu quả có thể được ứng dụng trong nhiều lĩnh vực khác nhau để theo dõi vị trí của người và phương tiện theo thời gian thực. Khả năng ứng dụng của nó có thể được xác nhận trong nhiều ngành công nghiệp khác nhau như an ninh, quản lý giao thông, mục đích thương mại, và nó có thể cung cấp an toàn và hiệu quả tốt hơn.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionEquipment.thumb,
        data: 'constructionEquipment',
        link: '/vi/enterprise/construction/equipment',
      },
    ],
  },
};
